WiseMetering.Model.Lead = WiseMetering.Model.extend({
    urlRoot: '/leads',

    convert: function(data) {
        // needs to be a formData object for logo file uploads
        let formData = new FormData();
        for (let key in data) {
            formData.append(key, data[key]);
        }

        return $.ajax({
            url: this.url() + '/convert',
            contentType: false,
            processData: false,
            dataType: 'json',
            data: formData,
            type: 'POST'
        });
    }
});
